import mockOrFetch from "./mockOrFetch";
import mockData from "./mock";

const getGateways = (lang, alias) => {
	const packageGatewaysAPI = `${process.env.GATSBY_HOTEL_INFOSERVICE_API}/sunwing/${lang}/hotelNameCode/${alias}`;

	return mockOrFetch({ apiUrl: packageGatewaysAPI, mockData, useMock: false });
};

export default getGateways;
